var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5 0C13.2086 0 0 13.2086 0 29.5C0 45.7914 13.2086 59 29.5 59C45.7914 59 59 45.7914 59 29.5C59 13.2086 45.7914 0 29.5 0ZM43.9894 20.21L39.1465 43.0233C38.79 44.6409 37.8264 45.0342 36.4817 44.2721L29.1067 38.8392L25.5519 42.2661C25.2077 42.7086 24.6743 42.9913 24.0769 42.9913C24.072 42.9913 24.0695 42.9913 24.0646 42.9913L24.5882 35.4836L38.2566 23.1378C38.8466 22.6142 38.1238 22.3167 37.3396 22.8404L20.4533 33.4751L13.1767 31.2036C11.6033 30.7046 11.5591 29.6303 13.5085 28.8584L41.9416 17.8991C43.2642 17.4173 44.4147 18.2138 43.987 20.2124L43.9894 20.21Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.f0147d7346a694bde18233681caa755b.svg";
export { ForwardRef as ReactComponent };